import { Alert, Box, Container, Grid, Stack } from "@mui/material";
import { useEffect, useState } from "react";
import NewLayout from "../../layout/dashboard/NewLayout";
import { fetchCurrentUser } from "../../modules/users";
import AccountProfile from "../../components/MyProfile/AccountProfile";
// import AboutSection from "../../components/MyProfile/about/AboutSection";
import ChangePassword from "../../components/MyProfile/ChangePassword";
import DeleteAccount from "../../components/MyProfile/DeleteAccount";
import { ExportData } from "../../components/MyProfile/user-projects/user-data-export/ExportData";
import OrgAIConfiguration from "../../components/ai-config/OrgAIConfiguration";
import NotificationSettings from "../../components/MyProfile/notifications/notificationSettings";

const Account = () => {
  const [user, setUser] = useState({});
  const [error, setError] = useState(null);

  const fetchUserData = async () => {
    try {
      const res = await fetchCurrentUser();
      setUser(res);
    } catch (error) {
      setError(error.message || "An error occurred while fetching user data.");
    } finally {
    }
  };
  
  useEffect(() => {
    fetchUserData();
  }, []);
  return (
    <NewLayout>
      <Container maxWidth="xl">
        <Grid container spacing={2} justifyContent="center">
          <Grid item md={8}>
            {error ? (
              <Alert severity="error" sx={{ mb: 2 }}>
                {error}
              </Alert>
            ) : (
              <>
                <Box />
                <Stack spacing={3}>
                  <Box>
                    <Grid
                      container
                      spacing={3}
                      sx={{ display: "flex", justifyContent: "center", mt: 1 }}
                    >
                      <Grid item xs={12} md={12} lg={12}>
                        <AccountProfile
                          user={user}
                          fetchUserData={fetchUserData}
                        />
                      </Grid>
                      {/* <Grid item xs={12} md={12} lg={12}>
                        <AboutSection
                          user={user}
                          fetchUserData={fetchUserData}
                        />
                      </Grid> */}
                      {user.platform === "web" && (
                        <Grid item xs={12} md={12} lg={12}>
                          <ChangePassword user={user} />
                        </Grid>
                      )}
                      <Grid item xs={12} md={12} lg={12}>
                        {(user.role === "org-admin" ||
                          user.role === "org-manager") && (
                            <>
                              <ExportData />
                              <OrgAIConfiguration user={user} />
                          </>
                          )}
                        {user.role === "org-admin" && (
                          <>
                            <DeleteAccount user={user} />
                          </>
                        )}
                      </Grid>
                    </Grid>
                  </Box>
                </Stack>
              </>
            )}
          </Grid>
        </Grid>
      </Container>
    </NewLayout>
  );
};

export default Account;
